import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** بعد از عوض شدن صفحه، اسکرول را از بالا شروع کن (SPA). */
export default function ScrollToTop() {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;
	}, [pathname]);

	return null;
}
